document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('[data-custom-header]');
  if (!header) return;

  /* ---------- Sticky background on scroll ---------- */
  function handleScroll() {
    if (window.scrollY > 20) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }
  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();

  /* ---------- Mobile drawer menu ---------- */
  var menuToggle = header.querySelector('[data-mobile-menu-toggle]');
  var menuClose = header.querySelector('[data-mobile-menu-close]');
  var drawer = header.querySelector('[data-mobile-drawer]');
  var overlay = header.querySelector('[data-mobile-overlay]');

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openDrawer);
  if (menuClose) menuClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* ---------- Mobile submenu accordion ---------- */
  var submenuToggles = header.querySelectorAll('[data-mobile-submenu-toggle]');
  submenuToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var submenu = btn.nextElementSibling;
      var isOpen = submenu.classList.contains('is-open');
      // close all others
      header.querySelectorAll('.mobile-drawer__submenu.is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
      if (!isOpen) submenu.classList.add('is-open');
    });
  });

  /* ---------- Close drawer on resize to desktop ---------- */
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 990) {
      closeDrawer();
    }
  });

  /* ==========================================================================
     LIVE / REAL-TIME SEARCH (Shopify predictive search)
     ========================================================================== */
  var searchToggle = header.querySelector('[data-search-toggle]');
  var searchPanel = header.querySelector('[data-search-panel]');
  var searchClose = header.querySelector('[data-search-close]');
  var searchInput = header.querySelector('[data-search-input]');
  var searchResults = header.querySelector('[data-search-results]');
  var searchDebounceTimer;
  var searchAbortController;

  function openSearch() {
    searchPanel.classList.add('is-open');
    if (searchInput) searchInput.focus();
  }

  function closeSearch() {
    searchPanel.classList.remove('is-open');
    if (searchResults) {
      searchResults.innerHTML = '';
    }
  }

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      if (searchPanel.classList.contains('is-open')) {
        closeSearch();
      } else {
        openSearch();
      }
    });
  }

  if (searchClose && searchPanel) {
    searchClose.addEventListener('click', closeSearch);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function renderSearchResults(results, query) {
    if (!searchResults) return;

    var products = (results && results.products) || [];

    if (!products.length) {
      searchResults.innerHTML =
        '<div class="search-no-results">No results for &ldquo;' + escapeHtml(query) + '&rdquo;</div>';
      return;
    }

    var html = '<ul class="search-results__list">';
    products.forEach(function (product) {
      html +=
        '<li class="search-results__item">' +
        '<a href="' + product.url + '">' +
        (product.image
          ? '<img src="' + product.image + '" alt="" loading="lazy">'
          : '') +
        '<span>' +
        '<span class="search-results__title">' + escapeHtml(product.title) + '</span>' +
        '<span class="search-results__price">' + (product.price || '') + '</span>' +
        '</span>' +
        '</a>' +
        '</li>';
    });
    html += '</ul>';

    searchResults.innerHTML = html;
  }

  function fetchPredictiveSearch(query) {
    if (!searchResults) return;

    if (searchAbortController) {
      searchAbortController.abort();
    }
    searchAbortController = ('AbortController' in window) ? new AbortController() : null;

    var url =
      '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,article,page' +
      '&resources[limit]=6' +
      '&resources[options][unavailable_products]=last';

    fetch(url, searchAbortController ? { signal: searchAbortController.signal } : {})
      .then(function (res) { return res.json(); })
      .then(function (data) {
        renderSearchResults(data && data.resources ? data.resources.results : null, query);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        console.error('Predictive search error:', err);
      });
  }

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();

      clearTimeout(searchDebounceTimer);

      if (query.length < 2) {
        searchResults.innerHTML = '';
        return;
      }

      searchDebounceTimer = setTimeout(function () {
        fetchPredictiveSearch(query);
      }, 300); // debounce so it doesn't fire a request on every keystroke
    });
  }

  /* ==========================================================================
     REAL-TIME CART COUNT
     Works with Shopify's native AJAX cart endpoints (/cart/add.js, /cart/change.js,
     /cart/update.js, /cart/clear.js) automatically — no need to change your
     add-to-cart buttons. It also listens for 'cart:updated' / 'cart:refresh'
     custom events in case other sections/apps already dispatch them.
     ========================================================================== */
  var CustomHeaderCart = {
    countEl: header.querySelector('[data-cart-count]'),

    setCount: function (count) {
      if (!this.countEl) return;
      this.countEl.textContent = count;
      this.countEl.classList.toggle('is-hidden', count === 0);
      this.countEl.classList.remove('is-bumped');
      // force reflow so the bump animation can replay on repeated updates
      void this.countEl.offsetWidth;
      this.countEl.classList.add('is-bumped');
    },

    refresh: function () {
      var self = this;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          self.setCount(cart.item_count);
          document.dispatchEvent(
            new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count, cart: cart } })
          );
        })
        .catch(function (err) {
          console.error('Cart refresh error:', err);
        });
    }
  };

  window.CustomHeaderCart = CustomHeaderCart;

  // If some other script on the page already dispatches this, just use it.
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && typeof event.detail.itemCount !== 'undefined') {
      CustomHeaderCart.setCount(event.detail.itemCount);
    }
  });
  document.addEventListener('cart:refresh', function () {
    CustomHeaderCart.refresh();
  });

  // Auto-detect cart mutations by watching fetch() calls to Shopify's cart endpoints.
  // This covers most themes/apps without needing any code changes on their end.
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var fetchPromise = nativeFetch.apply(this, arguments);
    try {
      var firstArg = arguments[0];
      var reqUrl = (firstArg && firstArg.url) || firstArg || '';
      if (typeof reqUrl === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(reqUrl)) {
        fetchPromise.then(function () {
          CustomHeaderCart.refresh();
        });
      }
    } catch (e) {
      /* no-op — never let this break the original fetch call */
    }
    return fetchPromise;
  };

  // Fallback for plain (non-AJAX) <form action="/cart/add"> submits.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && /\/cart\/add/.test(form.action)) {
      setTimeout(function () { CustomHeaderCart.refresh(); }, 400);
    }
  });

  /* ==========================================================================
     REAL-TIME WISHLIST COUNT
     Since wishlist logic usually lives in a separate app/script, this exposes a
     small generic API + listens for a 'wishlist:updated' custom event and for
     localStorage changes (the common pattern for lightweight/custom wishlists).
     Hook your wishlist code to this by doing either of:
       document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: 3 } }));
     or simply call:
       window.CustomHeaderWishlist.updateCount(3);
     ========================================================================== */
  var CustomHeaderWishlist = {
    countEl: header.querySelector('[data-wishlist-count]'),

    updateCount: function (count) {
      if (!this.countEl) return;
      this.countEl.textContent = count;
      this.countEl.classList.toggle('is-hidden', count === 0);
      this.countEl.classList.remove('is-bumped');
      void this.countEl.offsetWidth;
      this.countEl.classList.add('is-bumped');
    },

    // Best-effort default: if the wishlist app stores its data under
    // localStorage key "wishlist" as a JSON array, this picks it up automatically.
    refreshFromStorage: function () {
      try {
        var raw = localStorage.getItem('wishlist');
        if (raw === null) return;
        var items = JSON.parse(raw);
        this.updateCount(Array.isArray(items) ? items.length : 0);
      } catch (e) {
        /* wishlist app uses a different storage shape — ignore, use custom events instead */
      }
    }
  };

  window.CustomHeaderWishlist = CustomHeaderWishlist;

  document.addEventListener('wishlist:updated', function (event) {
    if (event.detail && typeof event.detail.count !== 'undefined') {
      CustomHeaderWishlist.updateCount(event.detail.count);
    } else {
      CustomHeaderWishlist.refreshFromStorage();
    }
  });

  // Picks up changes made in other tabs, and by apps that just write to localStorage.
  window.addEventListener('storage', function (e) {
    if (e.key === 'wishlist') CustomHeaderWishlist.refreshFromStorage();
  });

  // Initial sync on page load.
  CustomHeaderWishlist.refreshFromStorage();
});